var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResButtonsStudyAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Black{fill:#727272;}\r\n\t.Yellow{fill:#FFB115;}\r\n\t.Blue{fill:#1177D7;}\r\n\t.Green{fill:#039C23;}\r\n\t.Red{fill:#D11C1C;}\r\n\t.White{fill:#FFFFFF;}\r\n\t.st0{opacity:0.75;}\r\n\t.st1{opacity:0.5;}\r\n\t.st2{opacity:0.25;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AddGroupHeader_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    className: "Blue",
    width: 14,
    height: 6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M18,18H4v-2h14V18z M18,20H4v2h14V20z M18,24H4v2h14V24z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Black",
    d: "M20,14v14H2V6h16h2h2V5c0-0.5-0.5-1-1-1H1C0.5,4,0,4.5,0,5v24c0,0.5,0.5,1,1,1h20c0.5,0,1-0.5,1-1V18v-4H20z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Green",
    points: "32,8 28,8 28,4 24,4 24,8 20,8 20,12 24,12 24,16 28,16 28,12 32,12  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResButtonsStudyAdd);
export default __webpack_public_path__ + "static/media/resButtonsStudyAdd.fca8fb633e58071f33495264e0f714d9.svg";
export { ForwardRef as ReactComponent };